// Zuordnung der Icon-Namen aus navigation.js / onboardingContent.js zu lucide-react
import {
  Archive, BookOpen, Building2, ChartColumn, CircleCheckBig, ClipboardList, FilePenLine, FileText, Folder, Hammer,
  House, Inbox, KeyRound, LayoutGrid, LifeBuoy, MonitorSmartphone, Newspaper, Search, SearchX, Settings, Shield,
  ShieldCheck, ShoppingCart, Sparkles, Trophy, Truck, Users, WifiOff, Wrench
} from 'lucide-react';

export const ICONS = {
  home: House,
  news: Newspaper,
  trophy: Trophy,
  search: Search,
  searchX: SearchX,
  devices: MonitorSmartphone,
  cart: ShoppingCart,
  clipboard: ClipboardList,
  inbox: Inbox,
  tools: Wrench,
  book: BookOpen,
  lifebuoy: LifeBuoy,
  key: KeyRound,
  admin: ShieldCheck,
  wrench: Wrench,
  building: Building2,
  folder: Folder,
  filePen: FilePenLine,
  fileText: FileText,
  archive: Archive,
  truck: Truck,
  users: Users,
  shield: Shield,
  chart: ChartColumn,
  toolbox: Hammer,
  settings: Settings,
  sparkles: Sparkles,
  layout: LayoutGrid,
  wifiOff: WifiOff,
  check: CircleCheckBig
};

export const iconFor = (name) => ICONS[name] || LayoutGrid;
